import { RouterTabOption } from 'lib/components/RouterTabs';
import { exists } from 'lib/types';
import { selectActiveOrganization, selectUser } from 'redux/auth';
import { useAppSelector } from 'redux/hooks';
import { CUSTOMER_REPORTS_ROUTES, PUB_REPORTS_ROUTES } from 'router/routes';
import {
  ShoppingBagIcon,
  UserGroupIcon,
  DocumentTextIcon,
  CalculatorIcon,
  NewspaperIcon
} from '@heroicons/react/24/outline';
import { OccupationType } from 'lib/enums';

export function useValidReportsTabs(): RouterTabOption[] {
  const activeOrganization = useAppSelector(selectActiveOrganization);
  const user = useAppSelector(selectUser);

  if (!exists(activeOrganization)) return [];

  const isPublisher =
    user?.data().occupation === OccupationType.publishing.value;

  if (isPublisher) {
    return [
      {
        path: PUB_REPORTS_ROUTES.PUBLIC_NOTICES,
        enabled: true,
        label: 'Public Notices',
        Icon: NewspaperIcon
      },
      {
        path: PUB_REPORTS_ROUTES.PRODUCTS,
        enabled: true,
        label: 'Products',
        Icon: ShoppingBagIcon
      },
      {
        path: PUB_REPORTS_ROUTES.CUSTOMERS,
        enabled: true,
        label: 'Customers',
        Icon: UserGroupIcon
      },
      {
        path: PUB_REPORTS_ROUTES.PAGINATION,
        enabled: true,
        label: 'Pagination',
        Icon: DocumentTextIcon
      },
      {
        path: PUB_REPORTS_ROUTES.ACCOUNTING,
        enabled: true,
        label: 'Accounting',
        Icon: CalculatorIcon
      }
    ];
  }

  return [
    {
      path: CUSTOMER_REPORTS_ROUTES.PRODUCTS,
      enabled: true,
      label: 'Products',
      Icon: ShoppingBagIcon
    },
    {
      path: CUSTOMER_REPORTS_ROUTES.ACCOUNTING,
      enabled: true,
      label: 'Accounting',
      Icon: CalculatorIcon
    }
  ];
}
